import { useEffect, useRef } from 'react';
import FilterPanel, { useGlobalFilterBundle } from './FilterPanel';
import { formatScaledCount } from '../lib/scaling';
import { useBlobStore } from '../state/blobStore';
import { useFilteredIndices } from '../state/filterStore';
import { useSelectionStore } from '../state/selectionStore';
import { useUiStore } from '../state/uiStore';

function StatusLine() {
  const mode = useSelectionStore((s) => s.mode);
  const baseSelection = useSelectionStore((s) => s.baseSelection);
  const filtered = useFilteredIndices();
  const blob = useBlobStore((s) => s.blob);
  const sampleSize = blob?.meta.personCount ?? 0;

  let scope = 'All people';
  if (mode === 'drawing') scope = 'Drawing selection…';
  else if (mode === 'selected' && baseSelection) {
    scope = `Lasso · ${formatScaledCount(baseSelection.length, sampleSize)}`;
  }

  const matchedLabel = filtered
    ? formatScaledCount(filtered.indices.length, sampleSize)
    : '—';

  return (
    <div className="filter-overlay__status" aria-live="polite">
      <span className="filter-overlay__status-scope">{scope}</span>
      <span className="filter-overlay__status-sep">·</span>
      <span className="filter-overlay__status-matched">
        matched <strong>{matchedLabel}</strong>
      </span>
    </div>
  );
}

export default function FilterOverlay() {
  const open = useUiStore((s) => s.filterPanelOpen);
  const setOpen = useUiStore((s) => s.setFilterPanelOpen);
  const mode = useSelectionStore((s) => s.mode);
  const prevMode = useRef(mode);
  const bundle = useGlobalFilterBundle();

  useEffect(() => {
    if (prevMode.current === 'idle' && mode !== 'idle') {
      setOpen(true);
    }
    prevMode.current = mode;
  }, [mode, setOpen]);

  if (!open) return null;

  return (
    <section className="filter-overlay" aria-label="Filter">
      <header className="filter-overlay__header">
        <button
          type="button"
          className="filter-overlay__close"
          aria-label="Close Filter panel"
          onClick={() => setOpen(false)}
        >
          ×
        </button>
      </header>
      <StatusLine />
      <div className="filter-overlay__body">
        <FilterPanel bundle={bundle} />
      </div>
    </section>
  );
}
